import { useMutation } from 'react-query';

type CompressImageParams = {
  imageData: string;
  quality?: number;
};

export const useCompressImageMutation = () => {
  return useMutation({
    mutationFn: async ({ imageData, quality = 0.7 }: CompressImageParams): Promise<string> => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = imageData;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext('2d');
          if (!ctx) return reject(new Error('Canvas context 생성 실패'));

          ctx.drawImage(img, 0, 0);
          const compressed = canvas.toDataURL('image/jpeg', quality);
          resolve(compressed);
        };

        img.onerror = () => reject(new Error('이미지 로딩 실패'));
      });
    }
  });
};
